<template>
  <div style="width: 100%; height: 100%" v-loading="true"></div>
</template>

<script>
import apis from '@/utils/apis';
import Cookies from 'js-cookie';

export default {
  mounted: function () {
    this.jumpFirstPage();
  },
  methods: {
    jumpFirstPage() {
      this.$getJSON(apis.AppList, { appType: 2 }).then((res) => {
        const appList = res.data;
        if (appList && appList.length) {
          const appId = appList[0]['appId'];
          this.initAppMenu(appId);
          return;
        }
        this.signout();
      });
    },
    initAppMenu: async function (appId) {
      this.$getJSON(`${apis.App}/${appId}`).then((res) => {
        const menu = res.data || [];
        const firstMenu = menu[0] || {};
        const firstMenuItem = firstMenu.children && firstMenu.children[0] ? firstMenu.children[0] : firstMenu;
        this.jump(firstMenuItem.loadRes);
      });
    },
    // 退出登录
    signout: function () {
      this.$postJSON(apis.Logout).finally(() => {
        this.$store.commit('LOGINOUT');
        Cookies.remove('loginName', { path: '/' });
        Cookies.remove('token', { path: '/' });
        Cookies.remove('nonMetric', { path: '/' });
        Cookies.remove('tokenTimeOut', { path: '/' });
        this.$router.replace({ path: '/login', query: {} });
      });
    },
  }
};
</script>
